/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCustomerUsersResponseJson } from './get-customer-users-response-json';
import { GetCustomerUsersResult } from '../results/get-customer-users-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomerCompanyDto } from '../models/customer-company-dto';
import { CustomerUserDto } from '../models/customer-user-dto';
import { CustomerContactDto } from '../models/customer-contact-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import { CustomerUser } from 'cases/models';
//</custom-head>

export class GetCustomerUsersResponse extends ResponseWithErrorGeneric<GetCustomerUsersResponseJson, GetCustomerUsersResult> implements IResponseWithErrorGeneric<GetCustomerUsersResult> {
  public customerCompany: CustomerCompanyDto;
  public users: CustomerUserDto[];
  public contacts: CustomerContactDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCustomerUsersResponse>) {
    super(response, GetCustomerUsersResult.Error);

    if (this.result !== GetCustomerUsersResult.Success) {
      return;
    }

    if (this.body.customerCompany != null) {
      this.customerCompany = new CustomerCompanyDto(this.body.customerCompany);
    }

    if (this.body.users != null) {
      this.users = this.body.users.map(user => new CustomerUser(user));
    }

    this.contacts = this.body.contacts.map(c => new CustomerContactDto(c));
  }
  //</custom-body>
}
